// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/auth/current */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>('/api/auth/current', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/login/outLogin', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/auth/login */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<{
    code: number;
    message: string;
    data: API.LoginResult['data'];
    timestamp: number;
  }>('/api/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

/** 获取广告统计数据 POST /api/statistic/advert/data */
export async function getAdvertStatistic(
  body?: {[key: string]: any },
  options?: { [key: string]: any },
) {
  return request<API.AdvertStatisticResponse>('/api/statistic/advert/data', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 我的广告收藏夹列表 GET /api/adminstat/favorite/list */
export async function getAdminstatFavoriteList(
  options?: { [key: string]: any },
) {
  return request<API.AdminstatFavoriteListResponse>(
    '/api/adminstat/favorite/list',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 一键收藏或修改收藏夹 POST /api/adminstat/favorite */
export async function saveAdminstatFavorite(
  body?: { [key: string]: any },
  options?: { [key: string]: any },
) {
  return request<API.AdminstatFavoriteResponse>('/api/adminstat/favorite', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 删除收藏夹 DELETE /api/adminstat/favorite/{id} */
export async function deleteAdminstatFavorite(
  id: number,
  options?: { [key: string]: any },
) {
  return request<API.AdminstatFavoriteResponse>(
    `/api/adminstat/favorite/${id}`,
    {
      method: 'DELETE',
      ...(options || {}),
    },
  );
}

/** 获取渠道统计数据 POST /api/statistic/channel/data */
export async function getChannelStatistic(
  body?: {[key: string]: any },
  options?: { [key: string]: any },
) {
  return request<API.AdvertStatisticResponse>('/api/statistic/channel/data', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 根据广告和投放查询流量分配 GET /api/flow/distribute */
export async function getFlowDistribute(
  params: { adid: number; addid: number },
  options?: { [key: string]: any },
) {
  return request<{
    code?: number;
    message?: string;
    data?: {
      channelnames?: string;
      label?: string;
      filter?: string;
      type?: string;
      daylimit?: number;
    } | null;
  }>('/api/flow/distribute', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取产品统计数据 POST /api/statistic/product/data */
export async function getProductStatistic(
  body?: {[key: string]: any },
  options?: { [key: string]: any },
) {
  return request<API.AdvertStatisticResponse>('/api/statistic/product/data', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取产品对比统计数据 POST /api/statistic/product_compare/data */
export async function getProductCompareStatistic(
  body?: {[key: string]: any },
  options?: { [key: string]: any },
) {
  return request<API.ProductCompareResponse>('/api/statistic/product/compare', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取产品渠道收益统计数据 POST /api/statistic/yongjin/data */
export async function getYongjinStatistic(
  body?: {[key: string]: any },
  options?: { [key: string]: any },
) {
  return request<API.ChannelYongjinReportResponse>('/api/statistic/yongjin/data', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

export async function updateWarnThreshold(
  body?: { [key: string]: any },
  options?: { [key: string]: any },
) {
  return request<any>('/api/warn/threshold', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取渠道小时统计数据 POST /api/statistic/channel/hour */
export async function getChannelHourStatistic(
  body?: {[key: string]: any },
  options?: { [key: string]: any },
) {
  return request<API.AdvertStatisticResponse>('/api/statistic/hour/data', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取菜单列表 GET /api/privilege/menu */
export async function getMenus(options?: { [key: string]: any }) {
  return request<API.MenuResponse>('/api/privilege/menu', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取渠道列表 POST /api/channel/list */
export async function getChannelList(
  body?: API.ChannelListParams,
  options?: { [key: string]: any },
) {
  return request<API.ChannelListResponse>('/api/channel/list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}


/** 获取渠道选项（按当日渠道请求量倒序，不分页）POST /api/channel/option */
export async function getChannelOptionList(
  body?: API.ChannelListParams,
  options?: { [key: string]: any },
) {
  return request<API.ChannelOptionResponse>('/api/channel/option', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取字典数据 GET /api/dictionary/{type} */
export async function getDictionary(
  type: string,
  options?: { [key: string]: any },
) {
  return request<API.DictionaryResponse>(`/api/dictionary/${type}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 创建渠道 POST /api/channel */
export async function createChannel(
  body?: API.ChannelCreateParams,
  options?: { [key: string]: any },
) {
  return request<API.ChannelCreateResponse>('/api/channel', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 更新渠道 PUT /api/channel */
export async function updateChannel(
  body?: API.ChannelUpdateParams,
  options?: { [key: string]: any },
) {
  return request<API.ChannelUpdateResponse>('/api/channel', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 批量删除渠道 DELETE /api/channel */
export async function deleteChannels(
  body?: API.ChannelDeleteParams,
  options?: { [key: string]: any },
) {
  return request<API.ChannelDeleteResponse>('/api/channel', {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取客户列表 POST /api/custom/list */
export async function getCustomList(
  body?: API.CustomListParams,
  options?: { [key: string]: any },
) {
  return request<API.CustomListResponse>('/api/custom/page', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取客户列表 POST /api/custom/list */
export async function getAllCustomList(
  body?: API.CustomListParams,
  options?: { [key: string]: any },
) {
  return request<API.CustomListResponse>('/api/custom/list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 创建客户 POST /api/custom */
export async function createCustom(
  body?: API.CustomCreateParams,
  options?: { [key: string]: any },
) {
  return request<API.CustomCreateResponse>('/api/custom', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 更新客户 PUT /api/custom */
export async function updateCustom(
  body?: API.CustomUpdateParams,
  options?: { [key: string]: any },
) {
  return request<API.CustomUpdateResponse>('/api/custom', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 批量删除客户 DELETE /api/custom */
export async function deleteCustoms(
  body?: API.CustomDeleteParams,
  options?: { [key: string]: any },
) {
  return request<API.CustomDeleteResponse>('/api/custom', {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取广告列表 POST /api/advert/list */
export async function getAdvertList(
  body?: API.AdvertListParams,
  options?: { [key: string]: any },
) {
  return request<API.AdvertListResponse>('/api/advert/list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 创建广告 POST /api/advert */
export async function createAdvert(
  body?: API.AdvertCreateParams,
  options?: { [key: string]: any },
) {
  return request<API.AdvertCreateResponse>('/api/advert', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 更新广告 PUT /api/advert */
export async function updateAdvert(
  body?: API.AdvertUpdateParams,
  options?: { [key: string]: any },
) {
  return request<API.AdvertUpdateResponse>('/api/advert', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

export async function updateAdvertYongjin(id: number, enabled: boolean) {
  return request<API.AdvertUpdateResponse>('/api/advert/yongjin', {
    method: 'PUT',
    params: { id, enabled },
  });
}
/** 批量删除广告 DELETE /api/advert */
export async function deleteAdverts(
  body?: API.AdvertDeleteParams,
  options?: { [key: string]: any },
) {
  return request<API.AdvertDeleteResponse>('/api/advert', {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 更新广告状态 PUT /api/advert/status */
export async function updateAdvertStatus(
  body?: API.AdvertStatusParams,
  options?: { [key: string]: any },
) {
  return request<API.AdvertStatusResponse>('/api/advert/status', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取投放列表 POST /api/delivery/list */
export async function getDeliveryList(
  body?: API.DeliveryListParams,
  options?: { [key: string]: any },
) {
  return request<API.DeliveryListResponse>('/api/delivery/list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    timeout: 10000, // 30秒超时
    ...(options || {}),
  });
}

/** 创建投放 POST /api/delivery */
export async function createDelivery(
  body?: API.DeliveryCreateParams,
  options?: { [key: string]: any },
) {
  return request<API.DeliveryCreateResponse>('/api/delivery', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 更新投放 PUT /api/delivery */
export async function updateDelivery(
  body?: API.DeliveryUpdateParams,
  options?: { [key: string]: any },
) {
  return request<API.DeliveryUpdateResponse>('/api/delivery', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 批量删除投放 DELETE /api/delivery */
export async function deleteDeliveries(
  body?: API.DeliveryDeleteParams,
  options?: { [key: string]: any },
) {
  return request<API.DeliveryDeleteResponse>('/api/delivery', {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 更新投放状态 PUT /api/delivery/status */
export async function updateDeliveryStatus(
  body?: API.DeliveryStatusParams,
  options?: { [key: string]: any },
) {
  return request<API.DeliveryStatusResponse>('/api/delivery/status', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取日志列表 POST /api/log/list */
export async function getLogList(
  body?: API.LogListParams,
  options?: { [key: string]: any },
) {
  return request<API.LogListResponse>('/api/log/list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取日志详情 GET /api/log/{logid} */
export async function getLogDetail(
  logid: number,
  options?: { [key: string]: any },
) {
  return request<API.LogDetailResponse>(`/api/log/${logid}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取点击渠道日志 POST /api/log/click/channel */
export async function getClickChannelLog(
  body?: API.ClickChannelLogParams,
  options?: { [key: string]: any },
) {
  return request<API.ClickChannelLogResponse>('/api/log/click/channel', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取点击渠道日志详情 GET /api/log/click/channel/{logId} */
export async function getClickChannelLogDetail(
  logId: string,
  options?: { [key: string]: any },
) {
  return request<API.ClickChannelLogDetailResponse>(`/api/log/click/channel/${logId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 重新上报点击日志 POST /api/log/click/recall */
export async function recallClickLog(
  body?: API.RecallClickLogParams,
  options?: { [key: string]: any },
) {
  return request<API.RecallClickLogResponse>('/api/log/click/recall', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取点击客户日志 POST /api/log/click/custom */
export async function getClickCustomLog(
  body?: API.ClickChannelLogParams,
  options?: { [key: string]: any },
) {
  return request<API.ClickChannelLogResponse>('/api/log/click/custom', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取点击客户日志详情 GET /api/log/click/custom/{logId} */
export async function getClickCustomLogDetail(
  logId: string,
  options?: { [key: string]: any },
) {
  return request<API.ClickChannelLogDetailResponse>(`/api/log/click/custom/${logId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取回调客户日志 POST /api/log/callback/custom */
export async function getCallbackCustomLog(
  body?: API.ClickChannelLogParams,
  options?: { [key: string]: any },
) {
  return request<API.ClickChannelLogResponse>('/api/log/callback/custom', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取回调渠道日志 POST /api/log/callback/channel */
export async function getCallbackChannelLog(
  body?: API.ClickChannelLogParams,
  options?: { [key: string]: any },
) {
  return request<API.ClickChannelLogResponse>('/api/log/callback/channel', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取渠道账号列表 POST /api/channel/account/{channel} */
export async function getChannelAccountList(
  body?: API.ChannelAccountListParams,
  options?: { [key: string]: any },
) {
  const { channel, ...rest } = body || {};
  return request<API.ChannelAccountListResponse>(`/api/channel/account/${channel}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: rest || {},
    ...(options || {}),
  });
}

/** 创建渠道账号 POST /api/channel/account */
export async function createChannelAccount(
  body?: API.ChannelAccountCreateParams,
  options?: { [key: string]: any },
) {
  return request<API.ChannelAccountCreateResponse>('/api/channel/account', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 批量导入 WIFI 渠道账号 POST /api/channel/account/import */
export async function importWifiChannelAccounts(
  body: API.ChannelAccountCreateParams[],
  options?: { [key: string]: any },
) {
  return request<API.ChannelAccountImportResponse>(
    '/api/channel/account/import',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 更新渠道账号 PUT /api/channel/account */
export async function updateChannelAccount(
  body?: API.ChannelAccountUpdateParams,
  options?: { [key: string]: any },
) {
  return request<API.ChannelAccountUpdateResponse>('/api/channel/account', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 删除渠道账号 DELETE /api/channel/account */
export async function deleteChannelAccounts(
  body?: API.ChannelAccountDeleteParams,
  options?: { [key: string]: any },
) {
  return request<API.ChannelAccountDeleteResponse>('/api/channel/account', {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取渠道报表 POST /api/channel/report/{channel} */
export async function getChannelReport(
  body?: API.ChannelReportParams,
  options?: { [key: string]: any },
) {
  const { channel, ...rest } = body || {};
  return request<API.ChannelReportResponse>(`/api/channel/report/${channel}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: rest || {},
    ...(options || {}),
  });
}

/** 更新渠道报表预算 PUT /api/channel/report/{channel} */
export async function updateChannelReport(
  body?: API.ChannelReportUpdateParams,
  options?: { [key: string]: any },
) {
  const { channel, ...rest } = body || {};
  return request<API.ChannelReportUpdateResponse>(`/api/channel/report/${channel}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: rest || {},
    ...(options || {}),
  });
}

/** 获取 QPS 趋势图数据 GET /api/dashboard/qps/trend */
export async function getQPSTrend(
  params?: { minutes?: number },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: {
      resultType: string;
      result: Array<{
        metric: any;
        values: Array<[number, string]>;
      }>;
    };
    timestamp: number;
  }>('/api/dashboard/qps/trend', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取各个渠道QPS趋势图数据 GET /api/dashboard/qps/channel/trend */
export async function getQPSChannelTrend(
  params?: { minutes?: number },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: {
      resultType: string;
      result: Array<{
        metric: {
          endpoint?: string;
          [key: string]: any;
        };
        values: Array<[number, string]>;
      }>;
    };
    timestamp: number;
  }>('/api/dashboard/qps/channel/trend', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取返点配置分页列表 POST /api/rebateConfig/list */
export async function getRebateConfigList(
  body?: API.RebateConfigListParams,
  options?: { [key: string]: any },
) {
  return request<API.RebateConfigListResponse>('/api/rebateConfig/list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 新增返点配置 POST /api/rebateConfig */
export async function createRebateConfig(
  body?: API.RebateConfigCreateParams,
  options?: { [key: string]: any },
) {
  return request<API.RebateConfigResponse>('/api/rebateConfig', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 修改返点配置 PUT /api/rebateConfig */
export async function updateRebateConfig(
  body?: API.RebateConfigUpdateParams,
  options?: { [key: string]: any },
) {
  return request<API.RebateConfigResponse>('/api/rebateConfig', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 删除返点配置 DELETE /api/rebateConfig/{id} */
export async function deleteRebateConfig(
  id: number,
  options?: { [key: string]: any },
) {
  return request<API.RebateConfigDeleteResponse>(`/api/rebateConfig/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 手动刷新返点配置缓存 POST /api/rebateConfig/refresh-cache */
export async function refreshRebateConfigCache(
  options?: { [key: string]: any },
) {
  return request<API.RebateConfigDeleteResponse>('/api/rebateConfig/refresh-cache', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取各个客户 QPS趋势图数据 GET /api/dashboard/qps/custom/trend */
export async function getQPSCustomTrend(
  params?: { minutes?: number },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: {
      resultType: string;
      result: Array<{
        metric: {
          endpoint?: string;
          [key: string]: any;
        };
        values: Array<[number, string]>;
      }>;
    };
    timestamp: number;
  }>('/api/dashboard/qps/custom/trend', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取所有 host 列表 GET /api/dashboard/qps/host/list */
export async function getHostList(
  params?: { minutes?: number },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: string[];
    timestamp: number;
  }>('/api/dashboard/qps/host/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取指定 host 下各 channel 的请求量趋势 GET /api/dashboard/qps/host/channel/trend */
export async function getHostChannelTrend(
  params?: { host?: string; channel?: string; minutes?: number },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: {
      resultType: string;
      result: Array<{
        metric: {
          channel?: string;
          host?: string;
          [key: string]: any;
        };
        values: Array<[number, string]>;
      }>;
    };
    timestamp: number;
  }>('/api/dashboard/qps/host/channel/trend', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取客户请求中出现过的渠道列表 GET /api/dashboard/qps/host/channel/list */
export async function getRtaHostChannelList(
  params?: { minutes?: number },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: string[];
    timestamp: number;
  }>('/api/dashboard/qps/host/channel/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取有请求的渠道列表 GET /api/dashboard/qps/channel/list */
export async function getRtaChannelList(
  params?: { minutes?: number },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: string[];
    timestamp: number;
  }>('/api/dashboard/qps/channel/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取各 host 的 QPS 趋势，channel 为空表示全部渠道 GET /api/dashboard/qps/channel/host/trend */
export async function getRtaChannelHostTrend(
  params?: { channel?: string; minutes?: number },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: {
      resultType: string;
      result: Array<{
        metric: {
          host?: string;
          [key: string]: any;
        };
        values: Array<[number, string]>;
      }>;
    };
    timestamp: number;
  }>('/api/dashboard/qps/channel/host/trend', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取有请求的渠道列表（渠道广告指标） GET /api/dashboard/qps/advert/channel/list */
export async function getRtaAdvertChannelList(
  params?: { minutes?: number },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: string[];
    timestamp: number;
  }>('/api/dashboard/qps/advert/channel/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取有请求的广告ID与广告名称映射 GET /api/dashboard/qps/advert/adid/list */
export async function getRtaAdvertAdidList(
  params?: { minutes?: number },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: Record<string, string>;
    timestamp: number;
  }>('/api/dashboard/qps/advert/adid/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 渠道-广告 QPS 趋势，adid 非空按渠道分组，否则按广告分组 GET /api/dashboard/qps/advert/trend */
export async function getRtaAdvertQpsTrend(
  params?: { channel?: string; adid?: string; minutes?: number },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: {
      resultType: string;
      result: Array<{
        metric: {
          adid?: string;
          channel?: string;
          [key: string]: any;
        };
        values: Array<[number, string]>;
      }>;
    };
    timestamp: number;
  }>('/api/dashboard/qps/advert/trend', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取有请求的渠道列表（客户广告指标） GET /api/dashboard/qps/custom/advert/channel/list */
export async function getRtaCustomAdvertChannelList(
  params?: { minutes?: number },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: string[];
    timestamp: number;
  }>('/api/dashboard/qps/custom/advert/channel/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取有请求的广告ID与广告名称映射（客户广告指标） GET /api/dashboard/qps/custom/advert/adid/list */
export async function getRtaCustomAdvertAdidList(
  params?: { minutes?: number },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: Record<string, string>;
    timestamp: number;
  }>('/api/dashboard/qps/custom/advert/adid/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 客户-广告-渠道 QPS 趋势，分组规则同渠道广告趋势 GET /api/dashboard/qps/custom/advert/trend */
export async function getRtaCustomAdvertQpsTrend(
  params?: { channel?: string; adid?: string; minutes?: number },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: {
      resultType: string;
      result: Array<{
        metric: {
          adid?: string;
          channel?: string;
          [key: string]: any;
        };
        values: Array<[number, string]>;
      }>;
    };
    timestamp: number;
  }>('/api/dashboard/qps/custom/advert/trend', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取渠道日报列表 GET /api/channel-daily-metric/list */
export async function getChannelDailyMetricList(
  params?: { date?: string },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: Array<{
      endpoint: string;
      totalRequests: number;
      avgQps: number;
      peakQps: number;
    }>;
    timestamp: number;
  }>('/api/channel-daily-metric/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 手动触发渠道日报采集 POST /api/channel-daily-metric/collect */
export async function collectChannelDailyMetric(
  params?: { date?: string; days?: number },
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: { message?: string; date?: string; days?: number };
    timestamp: number;
  }>('/api/channel-daily-metric/collect', {
    method: 'POST',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取产品主数据分页列表 POST /api/productMaster/list */
export async function getProductMasterList(
  body?: API.ProductMasterListParams,
  options?: { [key: string]: any },
) {
  return request<API.ProductMasterListResponse>('/api/productMaster/list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 获取全部产品主数据分页列表(不过滤产品权限) POST /api/productMaster/listAll */
export async function getProductMasterListAll(
  body?: API.ProductMasterListParams,
  options?: { [key: string]: any },
) {
  return request<API.ProductMasterListResponse>('/api/productMaster/listAll', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}


/** 新增产品主数据 POST /api/productMaster */
export async function createProductMaster(
  body?: API.ProductMasterCreateParams,
  options?: { [key: string]: any },
) {
  return request<API.ProductMasterResponse>('/api/productMaster', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 修改产品主数据 PUT /api/productMaster */
export async function updateProductMaster(
  body?: API.ProductMasterUpdateParams,
  options?: { [key: string]: any },
) {
  return request<API.ProductMasterResponse>('/api/productMaster', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 删除产品主数据 DELETE /api/productMaster/{id} */
export async function deleteProductMaster(
  id: number,
  options?: { [key: string]: any },
) {
  return request<API.ProductMasterDeleteResponse>(`/api/productMaster/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 首页运营报表(产品→渠道/渠道→产品两级,今日 vs 对比) POST /api/dashboard/statistic/report */
export async function getHomeStatisticReport(
  body?: API.HomeStatisticForm,
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: API.HomeStatisticReportVo;
    timestamp: number;
  }>('/api/dashboard/statistic/report', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body || {},
    ...(options || {}),
  });
}

/** 首页小时对比曲线(当前 vs 对比,按绝对小时对齐) POST /api/dashboard/statistic/hour-trend */
export async function getHomeHourTrend(
  body?: API.HomeHourTrendForm,
  options?: { [key: string]: any },
) {
  return request<{
    code: number;
    message: string;
    data: API.HomeHourTrendItem[];
    timestamp: number;
  }>('/api/dashboard/statistic/hour-trend', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body || {},
    ...(options || {}),
  });
}
